import apiClient from '@/repositories/apiClient';
import { createApi } from '@reduxjs/toolkit/query/react';

const axiosBaseQuery = () => async (
  requestOpts,
  { _getState }
) => {
  try {
    const result = await apiClient({
      url: requestOpts.url,
      method: requestOpts.method,
      data: requestOpts.body,
    });

    return { data: result.data };
  } catch (err) {
    return { error: { status: err.response?.status, data: err.response?.data } };
  }
};

export const baseQuery = axiosBaseQuery;

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQuery(),
  tagTypes: ['Elements', 'VariantGroups', 'Tags', 'Locations', 'Users', 'OrgLicence', 'MyUsers', 'Organisations', 'Groups', 'AdminFeatures', 'LocationTypes', 'Devices', 'DeviceStream', 'Features', 'Streams', 'DefaultStreams', 'Contacts', 'Holidays', 'HolidayVariants', 'GroupHolidays', 'GroupOpeningHours', 'News', 'NewsMedia'],
  endpoints: () => ({}),
})

export const enhancedApi = api.enhanceEndpoints({
  endpoints: () => ({
    getElement: () => 'test',
  }),
})


export const getApiVersion = async () => {
  return await apiClient({
    method: 'get',
    url: '/version',
  });
}

